import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const getUsersMeCategoriesSelector =
  cloudChiprApi.endpoints.getUsersMeCategories.select();
